import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { formatCurrency } from "functions/formatCurrency";

export function SectionSummary({ title, total, showDecimals }) {
  return (
    <SummaryStyles>
      <SummaryTitle>{title} total</SummaryTitle>
      <SummaryTotal>{formatCurrency(total, { showDecimals })}</SummaryTotal>
    </SummaryStyles>
  );
}

SectionSummary.displayName = "SectionSummary";
SectionSummary.propTypes = {
  title: PropTypes.string,
  total: PropTypes.number,
  showDecimals: PropTypes.bool,
};

const SummaryStyles = styled.div`
  padding-top: var(--sm);
  padding-right: var(--md);
  text-align: right;
`;

const SummaryTitle = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  color: var(--dove-gray);
`;

const SummaryTotal = styled.div`
  font-size: 16px;
`;
